import httpClient from '../../../../shared/services/http/http-client';
import { IPostEmailQuestionnaireAnswer, IPostEmailQuestionnaireUserDeails } from './email-questionnaire-answer.model';

export default class EmailQuestionnaireAnswerService {
  http;

  constructor() {
    this.http = httpClient
  }

  async saveAnswers(token: string, details: IPostEmailQuestionnaireAnswer): Promise<any> {
    return this.http.post(`/email-questionnaire-answer/save-answers?token=${token}`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async checkIfCompleted(token: string, details: IPostEmailQuestionnaireUserDeails): Promise<any> {
    return this.http.post(`/email-questionnaire-answer/check-completion?token=${token}`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }
}

